// extracted by mini-css-extract-plugin
export default {"costsContainer":"AppPricePerUser_costsContainer__zaofT","costsTextAmount":"AppPricePerUser_costsTextAmount__YDk4g","costsText":"AppPricePerUser_costsText__ojG4U"};